const styles = theme => ({
  root: {
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px ${
      theme.spacing.unit
    }px ${theme.spacing.unit * 3}px`,
    width: '100%',
    backgroundColor: theme.palette.primary.light
  },
  contents: {
    borderTop: '1px solid rgba(0,0,0,0.12)',
    paddingTop: theme.spacing.unit * 3
  },
  buttonColor: {
    color: `${theme.palette.primary.main} !important`,
    top: '-10px'
  },
  panelBody: {
    marginTop: theme.spacing.unit * 2.5
  },
  unitDescription: {
    borderTop: '1px dashed rgba(0,0,0,0.12)',
    paddingTop: theme.spacing.unit * 3.125,
    marginTop: theme.spacing.unit * 3,
    marginBottom: '0',
    paddingBottom: theme.spacing.unit * 3.125
  },
  unitAction: {
    position: 'absolute',
    right: 28,
    top: 0,
    textDecoration: 'none'
  },
  unitActionLabel: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    textDecoration: 'none'
  },
  titleWrapper: {
    position: 'relative'
  },
  unitCalculationsContainer: {
    listStyleType: 'none',
    marginTop: 0,
    marginBottom: 0,
    paddingLeft: 0,
    '& li': {
      paddingBottom: theme.spacing.unit * 1.5
    }
  },
  addUnitButton: {
    marginTop: theme.spacing.unit * 8,
    paddingTop:theme.spacing.unit * 8,
  },
  checkboxContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    height: 56
  }
});

export default styles;
